import { z } from "zod";
import { WarehouseAutoTuneConfiguration } from "./types";

export const GET_WAREHOUSE = "GET-WAREHOUSE";
export const GET_WAREHOUSE_FILTERS = "GET-WAREHOUSE-FILTERS";
export const GET_LAST_UPDATED_TIME = "GET-LAST-UPDATED-TIME";
export const GET_WAREHOUSE_BY_ID = "GET-WAREHOUSE-BY-ID";
export const GET_WAREHOUSE_GROUP_BY_ID = "GET-WAREHOUSE-GROUP-BY-ID";
export const GET_ALL_QUERY_GROUPS = "GET-ALL-QUERY-GROUPS";
export const GET_WAREHOUSE_COST = "GET-WAREHOUSE-COST";
export const GET_WAREHOUSE_CLUSTER_UTILIZATION_EFFICIENCY =
  "GET-WAREHOUSE-CLUSTER-UTILIZATION-EFFICIENCY";
export const GET_WAREHOUSE_QUERY_EXECUTION_TIME = "GET-WAREHOUSE-QUERY-EXECUTION-TIME";
export const GET_WAREHOUSE_DECISION_DATA = "GET-WAREHOUSE-DECISION-DATA";
export const GET_WAREHOUSE_AUTO_SAVINGS = "GET-WAREHOUSE-AUTO-SAVINGS";
export const GET_WAREHOUSE_AUTO_SAVINGS_CONFIG = "GET-WAREHOUSE-AUTO-SAVINGS-CONFIG";
export const GET_WAREHOUSE_AUTO_SAVINGS_AUDIT_EVENTS = "GET-WAREHOUSE-AUTO-SAVINGS-AUDIT-EVENTS";
export const GET_WAREHOUSE_SCHEDULED_EVENTS = "GET-WAREHOUSE-SCHEDULED-EVENTS";
export const GET_AUTO_TUNE_CONFIGURATION = "GET-AUTO-TUNE-CONFIGURATION";
export const SET_AUTO_TUNE_CONFIGURATION = "SET-AUTO-TUNE-CONFIGURATION";
export const GET_AUTO_TUNE_HISTORY = "GET-AUTO-TUNE-HISTORY";

export type AUTO_TUNE_STATUS = "auto-tune-enabled" | "auto-tune-disabled";
export const AUTO_TUNE_MAP: {
  [key in AUTO_TUNE_STATUS]: {
    color: string;
    text: string;
    bgColor: string;
    value: string;
  };
} = {
  "auto-tune-enabled": {
    color: "#01CD8C",
    text: "On",
    bgColor: "#E6FAF4",
    value: "auto-tune-enabled",
  },
  "auto-tune-disabled": {
    color: "#EE140F",
    text: "Off",
    bgColor: "#FEE8E7",
    value: "auto-tune-disabled",
  },
};

export type TPredefinedFilter = {
  label: string;
  key: string;
  value: string;
};
export const PREDEFINED_FILTERS: TPredefinedFilter[] = [
  {
    label: "Eligible for Resizing",
    key: "resizeEligible",
    value: "true",
  },
  {
    label: "Resizing: Real-Time",
    key: "resizeMode",
    value: "auto_resize",
  },
  {
    label: "Resizing: Approval",
    key: "resizeMode",
    value: "manual_resize",
  },
];

export const TIME_PERIODS = [
  {
    label: "Last Day",
    period: 1,
  },
  {
    label: "Last Week",
    period: 7,
  },
  {
    label: "Last Month",
    period: 30,
  },
];

export const defaultAutoTuneConfig = {
  auto_tune_configuration: {
    auto_tune_enabled: false,
  },
  resizing_configuration: {
    resizing_enabled: false,
    resizing_configuration: {
      mode: "manual_resize",
      backoff_configuration: {
        max_latency_percentage: 150,
        max_queue_time_percentage: 150,
      },
      auto_approve_resizing: false,
    },
  },
  dynamic_resizing_eligible: null,
  dynamic_resizing_eligible_reason: null,
} satisfies WarehouseAutoTuneConfiguration;

export const autoTuneConfigurationFormSchema = z.object({
  auto_tune_enabled: z.boolean(),
  resizing_enabled: z.boolean(),
  resizing_mode: z.enum(["manual_resize", "auto_resize", "disabled"]), // Enum for mode
  max_latency_percentage: z.coerce.number().min(100, "Cannot be less than 100"), // Must be greater than 100
  max_queue_time_percentage: z.coerce.number().min(100, "Cannot be less than 100"), // Must be greater than 100
  auto_approve_resizing: z.boolean(),
});

// Chart and Timeline Constants
export const PERIOD_OPTIONS = [
  { label: "Week", value: 7 },
  { label: "Last 30 Days", value: 30 },
];

export const timeline_contentStyle = {
  fontFamily: "Lexend",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "12px",
  lineHeight: "15px",
  color: "#082247",
  display: "flex",
  alignItems: "center",
  marginLeft: "240px",
  padding: "14px",
  gap: "10px",
  border: "1px solid #E7E8EA",
  boxShadow: "none",
  borderRadius: "12px",
};

export const iconStyle = {
  width: "40px",
  height: "40px",
  display: "flex",
  background: "white",
  boxShadow: "none",
  border: "1px solid #E7E8EA",
  padding: "5px",
  marginTop: "10px",
};

export const WH_DateRange_Prefix = "chart";
